import React from 'react';

import es from "date-fns/locale/es";
import { format } from 'date-fns';

import { deletePromo } from '../../../actions/admin/promotion';
import { simpleConfirmDialog } from '../../../actions/swal_msg';
import { getPromotionCardText } from '../../../helpers/admin/promotion/promotionHelper';

import {
    Typography, Card, CardContent, CardHeader, IconButton, Menu, MenuItem
} from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';

const ActivePromotions = ({
    promotion, setOtherPromotion, setActivePromotion,
    setDialogStatus, setCurrentPromotion
}) => {
    const { _id, promo, start_date, end_date } = promotion;

    // eliminar promoción
    const deletePromotion = async () => {
        setAnchorEl(null);
        if (await simpleConfirmDialog('¿Deseas eliminar la promoción?', 'Eliminar')) {
            const req = await deletePromo({ _id });
            if (req.status) {
                setOtherPromotion(e => e.filter(e => e._id !== _id));
                setActivePromotion(e => e.filter(e => e._id !== _id));
            }
        }
    };

    // actualizar promoción (mostrar promoción en diálogo)
    const updatePromotion = async () => {
        setCurrentPromotion(e => ({ ...e, ...promotion }));
        setAnchorEl(null);
        setDialogStatus(true);
    };

    //Menu
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    
    return (
        <>
            <Card className='promotion_active_card'>
                <CardHeader
                    action={
                        <IconButton onClick={ handleClick }>
                            <MoreVertIcon />
                        </IconButton>
                    }
                    title={promo}
                    subheader={
                        `Vigencia: ${format(new Date(start_date), "d 'de' MMMM yyyy", { locale: es })} - ${format(new Date(end_date), "d 'de' MMMM yyyy", { locale: es })}`
                    }
                />
                <CardContent>
                    <Typography variant="body1">
                        { getPromotionCardText(promotion) }
                    </Typography>
                </CardContent>
            </Card>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={ deletePromotion }>Eliminar</MenuItem>
                <MenuItem onClick={ updatePromotion }>Actualizar</MenuItem>
            </Menu>
        </>
    );
};

export default ActivePromotions;